









































































import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import CdkNavigationProvider from "@/components/CdkNavigation/CdkNavigationProvider.vue";
import CdkFilterPassBadge from "@/components/CdkFilterPassBadge/CdkFilterPassBadge.vue";
import NotificationSettingsSwitch from "./NotificationSettingsSwitch.vue";
import DpaNotificationsAdDialogue from "@/components/DpaNotificationsAd/DpaNotificationsAdDialogue.vue";

@Component({
  components: {
    DpaNotificationsAdDialogue,
    CdkNavigationProvider,
    CdkFilterPassBadge,
    NotificationSettingsSwitch
  },
  computed: {
    ...mapState("filters", ["filters"])
  }
})
export default class NotificationSettings extends Vue {
  showDpaIdAppAd: boolean = false;
}
